import { AxiosError } from "axios";
import { CustomError } from "../types/custom-error";
import { ErrorPlatform } from "../types/error-platform";

export const errorTransform = (
  axiosError: AxiosError<ErrorPlatform>,
  unexpectedErrorText: string
) => {
  let error: CustomError = {
    message: unexpectedErrorText,
  };
  error = {
    message: axiosError.response?.data?.message ?? unexpectedErrorText,
  };

  return error;
};
